export function sortRows<T>(rows: T[], sortDirection: 'ASC'|'DESC'|null, sortColumn: (keyof T)|null): T[] {
  if (sortDirection === null || sortColumn === null) {
    return rows
  } else {
    const sortFactor = sortDirection === "ASC" ? 1 : -1
    return rows.sort((a, b) => {
      if (a[sortColumn] > b[sortColumn]) {
        return sortFactor
      } else {
        return -sortFactor
      }
    })
  }
}